import { z } from 'zod';
import { ErrorCode } from '../../shared/error-codes';
/**
 * External Contact Schema
 * Represents an external contact (customer, partner, vendor, etc.)
 */ export const ExternalContactSchema = z.object({
    _id: z.string(),
    name: z.string(),
    email: z.string().email(ErrorCode.FIELD_INVALID_EMAIL).optional(),
    description: z.string().optional(),
    type: z.string(),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
    deletedAt: z.number().optional()
});
/**
 * Populated External Contact Schema
 * Used when external contact references are populated with simplified data
 * Simplified version for populated references in API responses
 */ export const PopulatedExternalContactSchema = z.object({
    _id: z.string(),
    name: z.string(),
    email: z.string().optional(),
    type: z.string(),
    deletedAt: z.number().optional()
});

//# sourceMappingURL=external-contact.schema.js.map